import { Attribute } from '@emm/core/models/attribute.model';
import { createAction, props } from '@ngrx/store';
import {Item} from '@emm/core/models/item.model';
import {ItemLocaleResponse, Locale} from '@emm/core/models/locale.model';
import {ItemType} from '@emm/core/models/item-type.model';
import {LocationSetType} from '@emm/core/models/location-set-type.model';
import {LocationSet} from '@emm/core/models/location-set.model';
import {SearchFilter} from '@emm/core/models/search-filter';
import {Revotes} from '@emm/core/models/revotes.model';
import {Screen} from '@emm/core/models/screen.model';


export enum ManagementBaseAction {
    ChangeScreen = '[Management Page] Change Screen',
    Init = '[Management Page] Init',
    InitAttributes = '[Attributes Management] Init',
    InitConsumerTypes = '[Consumer Types Management] Init',
    InitItemGroupings = '[Item Groupings Management] Init',
    InitItems = '[Items Management] Init',
    InitItemTypes = '[Item Types Management] Init',
    InitLocationSets = '[Location Sets Management] Init',
    InitLocationSetTypes = '[Location Set Types Management] Init',
    InitMasterMenuSystem = '[Management Master Menu System] Init',
    InitMmsAdmin = '[MMS Admin Management] Init',
    InitLanguageAssignments = '[Language Assignments Management] Init',
    InitOperatorEmergency = '[Operator Locks Management] Init',
    InitSuccess = '[Management FX] Init Success',
    LoadAttributeDetail = '[Attributes Management] Load Attribute Detail',
    LoadAttributeDetailFailure = '[Management API] Load Attribute Detail Failure',
    LoadAttributeDetailSuccess = '[Management API] Load Attribute Detail Success',
    LoadItemDetail = '[Items Management] Load Item Detail',
    LoadItemDetailFailure = '[Items Management] Load Item Detail Failure',
    LoadItemDetailSuccess = '[Items Management] Load Item Detail Success',
    LoadItemLocaleDetail = '[Items Management] Load Item Locale Detail',
    LoadItemLocaleDetailFailure = '[Items Management] Load Item Locale Detail Failure',
    LoadItemLocaleDetailSuccess = '[Items Management] Load Item Locale Detail Success',
    LoadItemGroupingDetail = '[Item Groupings Management] Load Item Grouping Detail',
    LoadItemGroupingDetailFailure = '[Management API] Load Item Grouping Detail Failure',
    LoadItemGroupingDetailSuccess = '[Management API] Load Item Grouping Detail Success',
    LoadItemTypeDetail = '[Item Types Management] Load Item Type Detail',
    LoadItemTypeDetailFailure = '[Management API] Load Item Type Detail Failure',
    LoadItemTypeDetailSuccess = '[Management API] Load Item Type Detail Success',
    LoadLocationSetTypeDetail = '[Location Set Types Management] Load Location Set Type Detail',
    LoadLocationSetTypeDetailFailure = '[Management API] Load Location Set Type Detail Failure',
    LoadLocationSetTypeDetailSuccess = '[Management API] Load Location Set Type Detail Success',
    LoadRevoteDetail = '[Revote Management] Load Revote Detail',
    LoadRevoteDetailFailure = '[Revote Management] Load Revote Detail Failure',
    LoadRevoteDetailSuccess = '[Revote Management] Load Revote Detail Success',
    LoadAssignmentDetail = '[Language Assignments Management] Load Assignment Detail',
    LoadAssignmentDetailFailure = '[Language Assignments Management] Load Assignment Detail Failure',
    LoadAssignmentDetailSuccess = '[Language Assignments Management] Load Assignment Detail Success',
    SelectEmergencyItemDetail = '[Operator Locks Management] Select Item',
    SelectCountry = '[Management Page] Select Country',
    SelectLocationSet = '[Location Sets Management] Select Location Set',
    UpdateItem = '[Items Management] Update Item',
    UpdateItemFailure = '[Management API] Update Item Failure',
    UpdateItemGrouping = '[Item Groupings Management] Update Item Grouping',
    UpdateItemGroupingFailure = '[Management API] Update Item Grouping Failure',
    UpdateItemGroupingSuccess = '[Management API] Update Item Grouping Success',
    UpdateItemSuccess = '[Management API] Update Item Success',
    UpdateItemType = '[Item Types Management] Update Item Type',
    UpdateItemTypeFailure = '[Management API] Update Item Type Failure',
    UpdateItemTypeSuccess = '[Management API] Update Item Type Success',
    UpdateLocationSet = '[Location Sets Management] Update Location Set',
    UpdateLocationSetFailure = '[Management API] Update Location Set Failure',
    UpdateLocationSetSuccess = '[Management API] Update Location Set Success',
    UpdateLocationSetType = '[Location Set Types Management] Update Location Set Type',
    UpdateLocationSetTypeFailure = '[Management API] Update Location Set Type Failure',
    UpdateLocationSetTypeSuccess = '[Management API] Update Location Set Type Success',
    UpdateRevote = '[Revote Management] Update Revote',
    UpdateRevoteFailure = '[Management API] Update Revote Set Failure',
    UpdateRevoteSuccess = '[Management API] Update Revote Set Success',
    UpdateCategories = '[Revote Management] Update Categories',
    UpdateCategoriesFailure = '[Management API] Update Categories Failure',
    UpdateCategoriesSuccess = '[Management API] Update Categories Success',
    UpdateLocations = '[Revote Management] Update Locations',
    UpdateLocationsFailure = '[Management API] Update Locations Failure',
    UpdateLocationsSuccess = '[Management API] Update Locations Success',

    LoadAllLocation = '[Management Page] Load All Location',
    LoadAllLocationSuccess = '[Management API] Load All Location Success',
    LoadAllLocationFailure = '[Management API] Load All Location Failure',
    SearchLocation = '[Management Page] Search Location',
    StartLoading = '[Management Page] Start Progress Bar Success',
    LoadingSuccess = '[Management Page] Stop Progress Bar Success',
    LoadingFailure = '[Management Page] Progress Bar Failure',
}

export const ManagementBaseActions = {
    changeScreen: createAction(ManagementBaseAction.ChangeScreen, props<{ screen: Screen; navigate: boolean }>()),
    init: createAction(ManagementBaseAction.Init),
    initAttributes: createAction(ManagementBaseAction.InitAttributes),
    initConsumerTypes: createAction(ManagementBaseAction.InitConsumerTypes),
    initItemGroupings: createAction(ManagementBaseAction.InitItemGroupings),
    initItems: createAction(ManagementBaseAction.InitItems),
    initItemTypes: createAction(ManagementBaseAction.InitItemTypes),
    initLocationSets: createAction(ManagementBaseAction.InitLocationSets),
    initLocationSetTypes: createAction(ManagementBaseAction.InitLocationSetTypes),
    initMasterMenuSystem: createAction(ManagementBaseAction.InitMasterMenuSystem),
    initMmsAdmin: createAction(ManagementBaseAction.InitMmsAdmin),
    initLanguageAssignments: createAction(ManagementBaseAction.InitLanguageAssignments),
    initOperatorEmergency: createAction(ManagementBaseAction.InitOperatorEmergency),
    initSuccess: createAction(ManagementBaseAction.InitSuccess, props<{ screens: Screen[] }>()),
    loadAttributeDetail: createAction(ManagementBaseAction.LoadAttributeDetail),
    loadAttributeDetailFailure: createAction(ManagementBaseAction.LoadAttributeDetailFailure, props<{ error: any }>()),
    loadAttributeDetailSuccess: createAction(ManagementBaseAction.LoadAttributeDetailSuccess, props<{ attribute: Attribute }>()),
    loadItemDetail: createAction(ManagementBaseAction.LoadItemDetail),
    loadItemDetailFailure: createAction(ManagementBaseAction.LoadItemDetailFailure, props<{ error: any }>()),
    loadItemDetailSuccess: createAction(ManagementBaseAction.LoadItemDetailSuccess, props<{ item: Item }>()),
    loadItemLocaleDetail: createAction(ManagementBaseAction.LoadItemLocaleDetail,
        props<{ tag: string, country: string, language: string }>()),
    loadItemLocaleDetailFailure: createAction(ManagementBaseAction.LoadItemLocaleDetailFailure, props<{ error: any }>()),
    loadItemLocaleDetailSuccess: createAction(ManagementBaseAction.LoadItemLocaleDetailSuccess,
        props<{ itemLocale: ItemLocaleResponse }>()),
    loadItemGroupingDetail: createAction(ManagementBaseAction.LoadItemGroupingDetail, props<{ tag: string }>()),
    loadItemGroupingDetailFailure: createAction(ManagementBaseAction.LoadItemGroupingDetailFailure, props<{ error: any }>()),
    loadItemGroupingDetailSuccess: createAction(ManagementBaseAction.LoadItemGroupingDetailSuccess, props<{ item: Item }>()),
    loadItemTypeDetail: createAction(ManagementBaseAction.LoadItemTypeDetail),
    loadItemTypeDetailFailure: createAction(ManagementBaseAction.LoadItemTypeDetailFailure, props<{ error: any }>()),
    loadItemTypeDetailSuccess: createAction(ManagementBaseAction.LoadItemTypeDetailSuccess, props<{ itemType: ItemType }>()),
    loadLocationSetTypeDetail: createAction(ManagementBaseAction.LoadLocationSetTypeDetail),
    loadLocationSetTypeDetailFailure: createAction(ManagementBaseAction.LoadLocationSetTypeDetailFailure, props<{ error: any }>()),
    // tslint:disable-next-line:max-line-length
    loadLocationSetTypeDetailSuccess: createAction(ManagementBaseAction.LoadLocationSetTypeDetailSuccess, props<{ locationSetType: LocationSetType }>()),
    loadRevoteDetail: createAction(ManagementBaseAction.LoadRevoteDetail),
    loadRevoteDetailFailure: createAction(ManagementBaseAction.LoadRevoteDetailFailure, props<{ error: any }>()),
    loadRevoteDetailSuccess: createAction(ManagementBaseAction.LoadRevoteDetailSuccess, props<{ revote: any }>()),
    loadAssignmentDetail: createAction(ManagementBaseAction.LoadAssignmentDetail),
    loadAssignmentDetailFailure: createAction(ManagementBaseAction.LoadAssignmentDetailFailure, props<{ error: any }>()),
    loadAssignmentDetailSuccess: createAction(ManagementBaseAction.LoadAssignmentDetailSuccess, props<{ languageAssignment: any }>()),

    loadAllLocation: createAction(ManagementBaseAction.LoadAllLocation),
    loadAllLocationSuccess: createAction(
        ManagementBaseAction.LoadAllLocationSuccess,
        props<{ locationSets: LocationSet[] }>()
    ),
    loadAllLocationFailure: createAction(ManagementBaseAction.LoadAllLocationFailure, props<{ error: any }>()),
    searchLocation: createAction(ManagementBaseAction.SearchLocation, props<{ filter: SearchFilter }>()),
    selectCountry: createAction(ManagementBaseAction.SelectCountry, props<{ country: Locale }>()),
    selectEmergencyItemDetail: createAction(ManagementBaseAction.SelectEmergencyItemDetail, props<{ item: { tag: string } }>()),
    selectLocationSet: createAction(ManagementBaseAction.SelectLocationSet, props<{ locationSet: LocationSet }>()),
    updateItem: createAction(ManagementBaseAction.UpdateItem, props<{ tag: string; updates: any; dispatchReload: boolean }>()),
    updateItemFailure: createAction(ManagementBaseAction.UpdateItemFailure, props<{ error: any }>()),
    updateItemSuccess: createAction(ManagementBaseAction.UpdateItemSuccess, props<{ item: Item; dispatchReload: boolean }>()),
    updateItemType: createAction(ManagementBaseAction.UpdateItemType, props<{ tag: string; updates: any; dispatchReload: boolean }>()),
    updateItemTypeFailure: createAction(ManagementBaseAction.UpdateItemTypeFailure, props<{ error: any }>()),
    updateItemTypeSuccess: createAction(ManagementBaseAction.UpdateItemTypeSuccess,
        props<{ itemType: ItemType; dispatchReload: boolean }>()),
    updateItemGrouping: createAction(ManagementBaseAction.UpdateItemGrouping,
        props<{ tag: string; updates: any; dispatchReload: boolean }>()),
    updateItemGroupingFailure: createAction(ManagementBaseAction.UpdateItemGroupingFailure, props<{ error: any }>()),
    updateItemGroupingSuccess: createAction(ManagementBaseAction.UpdateItemGroupingSuccess,
        props<{ item: Item; dispatchReload: boolean }>()),
    updateLocationSet: createAction(ManagementBaseAction.UpdateLocationSet,
        props<{ tag: string; updates: any; dispatchReload: boolean }>()),
    updateLocationSetFailure: createAction(ManagementBaseAction.UpdateLocationSetFailure, props<{ error: any }>()),
    // tslint:disable-next-line:max-line-length
    updateLocationSetSuccess: createAction(ManagementBaseAction.UpdateLocationSetSuccess, props<{ locationSet: LocationSet; dispatchReload: boolean }>()),
    // tslint:disable-next-line:max-line-length
    updateLocationSetType: createAction(ManagementBaseAction.UpdateLocationSetType, props<{ tag: string; updates: any; dispatchReload: boolean }>()),
    updateLocationSetTypeFailure: createAction(ManagementBaseAction.UpdateLocationSetTypeFailure, props<{ error: any }>()),
    // tslint:disable-next-line:max-line-length
    updateLocationSetTypeSuccess: createAction(ManagementBaseAction.UpdateLocationSetTypeSuccess, props<{ locationSetType: LocationSetType; dispatchReload: boolean }>()),
    updateRevote: createAction(ManagementBaseAction.UpdateRevote, props<{ id: string; updates: any; dispatchReload: boolean }>()),
    updateRevoteFailure: createAction(ManagementBaseAction.UpdateRevoteFailure, props<{ error: any }>()),
    updateRevoteSuccess: createAction(ManagementBaseAction.UpdateRevoteSuccess, props<{ revote: Revotes; dispatchReload: boolean }>()),
    startLoading: createAction(ManagementBaseAction.StartLoading),
    loadingSuccess: createAction(ManagementBaseAction.LoadingSuccess),
    loadingFailure: createAction(ManagementBaseAction.LoadingFailure, props<{ error: any }>()),
};

export const AsyncActions = {
    loadActions: [
        ManagementBaseActions.loadItemDetail,
        ManagementBaseActions.loadItemLocaleDetail,
        ManagementBaseActions.updateItem,
        ManagementBaseActions.loadItemTypeDetail,
        ManagementBaseActions.updateItemType,
        ManagementBaseActions.loadLocationSetTypeDetail,
        ManagementBaseActions.updateLocationSetType,
        ManagementBaseActions.loadAttributeDetail,
        ManagementBaseActions.loadItemGroupingDetail,
        ManagementBaseActions.updateItemGrouping,
        ManagementBaseActions.updateLocationSet,
        ManagementBaseActions.updateRevote,
        ManagementBaseActions.loadRevoteDetail,
        ManagementBaseActions.loadAssignmentDetail,
        ManagementBaseActions.loadAllLocation,
        ManagementBaseActions.startLoading,
    ],
    successActions: [
        ManagementBaseActions.loadItemDetailSuccess,
        ManagementBaseActions.loadItemLocaleDetailSuccess,
        ManagementBaseActions.updateItemSuccess,
        ManagementBaseActions.loadItemTypeDetailSuccess,
        ManagementBaseActions.updateItemTypeSuccess,
        ManagementBaseActions.loadLocationSetTypeDetailSuccess,
        ManagementBaseActions.updateLocationSetTypeSuccess,
        ManagementBaseActions.loadAttributeDetailSuccess,
        ManagementBaseActions.loadItemGroupingDetailSuccess,
        ManagementBaseActions.updateItemGroupingSuccess,
        ManagementBaseActions.updateLocationSetSuccess,
        ManagementBaseActions.updateRevoteSuccess,
        ManagementBaseActions.loadRevoteDetailSuccess,
        ManagementBaseActions.loadAssignmentDetailSuccess,
        ManagementBaseActions.loadAllLocationSuccess,
        ManagementBaseActions.loadingSuccess,
    ],
    errorActions: [
        ManagementBaseActions.loadItemDetailFailure,
        ManagementBaseActions.loadItemLocaleDetailFailure,
        ManagementBaseActions.updateItemFailure,
        ManagementBaseActions.loadItemTypeDetailFailure,
        ManagementBaseActions.updateItemTypeFailure,
        ManagementBaseActions.loadLocationSetTypeDetailFailure,
        ManagementBaseActions.updateLocationSetTypeFailure,
        ManagementBaseActions.loadAttributeDetailFailure,
        ManagementBaseActions.loadItemGroupingDetailFailure,
        ManagementBaseActions.updateItemGroupingFailure,
        ManagementBaseActions.updateLocationSetFailure,
        ManagementBaseActions.updateRevoteFailure,
        ManagementBaseActions.loadRevoteDetailFailure,
        ManagementBaseActions.loadAssignmentDetailFailure,
        ManagementBaseActions.loadAllLocationFailure,
        ManagementBaseActions.loadingFailure,
    ]
};
